/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPH
 */
const Index = gql`
query VendorInvoiceReadQuery($vendorId: ID, $take: PositiveInt, $skip: Int)  {
  VendorInvoiceRead(vendorId: $vendorId, take: $take, skip: $skip) {
    id,
    message,
    status,
    amount,
    invoiceNumber,
    datedOn,
    billingStartDate,
    billingEndDate
  }
} 
`

/*
 * EXPORTS
 */
export default Index
